module.exports = __webpack_public_path__ + "eb4fdc6ea6689dcb802e66242c021473.png";